import { t } from 'i18next'

import { ad as service } from '~/modules/retailMedia/services/industry'

import { types } from './constants'

export const patchAd = ({
  body,
  id
}: {
  id: string
  body: { active: boolean }
}) => ({
  type: types.patch,
  payload: service.patch({ body, id })
})

export const cpcPatch = ({
  body,
  id,
  onSuccess,
  onError
}: {
  id: string
  body: { cpc: number | null; source?: 'bid_monitor'; suggested_value?: number }
  onSuccess?: () => void
  onError?: () => void
}) => ({
  values: { id, body },
  type: types.cpc_patch,
  payload: service.cpcPatch({ body, id }),
  successFeedbackMsg: t('rm:actions.industry.ad.updateCPC'),
  onSuccess,
  onError
})

export const cpmPatch = ({
  body,
  id,
  onSuccess,
  onError
}: {
  id: string
  body: { cpm: number | null; source?: 'bid_monitor'; suggested_value?: number }
  onSuccess?: () => void
  onError?: () => void
}) => ({
  values: { id, body },
  type: types.cpm_pactch,
  payload: service.cpmPatch({ body, id }),
  successFeedbackMsg: t('rm:actions.industry.ad.updateCPM'),
  onSuccess,
  onError
})

export default {
  patchAd,
  cpcPatch,
  cpmPatch
}
